const Coupon = {
  path: "",
  name: "",
  redirect: "/coupon",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/coupon",
      redirect: "/coupon",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Coupon",
      meta: {
        requiresAuth: true,
        activeUrl: "/coupon",
        parent: "coupon",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/coupon/index"),
          meta: {
            requiresAuth: true,
            activeUrl: "/coupon",
            parent: "coupon",

            lv: 2,
          },
        },
        {
          path: "details/:id",
          name: "Coupon Detail",
          component: () => import("@/views/pages/coupon/Detail"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/coupon",
            parent: "coupon",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Coupon;
